import { setPreference } from "src/services/PreferenceStore";
import { InnerViewFilter, OneViewFilter, stringToView } from "../toLocalStorage";
import { getViews } from "./getViews";
import { stripViewFilterPrefix } from "./stripViewFilterPrefix";

type PersistOptions = {
    gridKey: string;
    viewName: string;
    columnOrder: string[] | undefined;
    columnVisibility: Record<string, boolean> | undefined;
};

export const persistViewColumnState = (options: PersistOptions): OneViewFilter[] => {
    const { gridKey, viewName, columnOrder, columnVisibility } = options;

    const allPreviousValues = getViews({ gridKey });

    let found = false;
    const updatedFilters = allPreviousValues.reduce((acc, currentValue) => {
        if (currentValue.filterName === viewName) {
            found = true;
            acc[currentValue.filterName] = JSON.stringify({
                columnFilters: currentValue.columnFilters,
                columnOrder,
                columnVisibility,
            });
        } else {
            acc[currentValue.filterName] = JSON.stringify({
                columnFilters: currentValue.columnFilters,
                columnOrder: currentValue.columnOrder,
                columnVisibility: currentValue.columnVisibility,
            });
        }
        return acc;
    }, {} as InnerViewFilter);

    if (!found) {
        updatedFilters[viewName] = JSON.stringify({
            columnFilters: [],
            columnOrder,
            columnVisibility,
        });
    }

    const newFilterAsString = JSON.stringify(updatedFilters);
    setPreference("grid.views", stripViewFilterPrefix(gridKey), updatedFilters);

    return stringToView(newFilterAsString);
};
